import {DELETE_TEAMS_ERROR, DELETE_TEAMS_LOADING, DELETE_TEAMS_SUCCESS} from "../../../constant/actionTypes";

const deleteTeamReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_TEAMS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case DELETE_TEAMS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.teams,
            };
            return obj;
        }
        case DELETE_TEAMS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default deleteTeamReducer;